const tableColumn = {
    summaryTable: [{
        name: 'RESPONDENT',
        key: 'respondent__full_name',
        linkActive: false,
        link: '',
    },
    {
        name: 'RELATION',
        key: 'assessor_group__assessor_name',
        linkActive: false,
        link: '',
    },
    {
        name: 'STATUS',
        key: 'assessment_status__status_name',
        type: 'progressBubble',
        linkActive: false,
        link: '',
    },
    {
        name: 'MANAGE',
        key: 'report_accesss',
        type: 'modalOpeners',
        modalData: [{
            id: 0,
            modalStyle: 'icon',
            iconClass: 'fas fa-pencil-alt',
            disabledKey: 'is_submited',
            disabledWhenBool: true,
            funcType: 'edit',
            disability: 'is_admin_created',
            disability2: 'assessment_status__status_name',
            disabledDisability2: false            
        },{
            id: 1,
            modalStyle: 'icon',
            iconClass: 'fas fa-times',
            disabledKey: 'is_submited',
            disabledWhenBool: true,
            funcType: 'close',
            disability: 'is_admin_created',
            disability2: 'assessment_status__status_name',
            disabledDisability2: false
        }],
        modalStyle: 'icon',
        content: '',
        linkActive: false,
        link: ''
    },{
        name: 'REMIND',
        key: 'report_accesss',
        modalData: [{
            id: 0,
            modalStyle: 'icon',
            iconClass: 'fas fa-paper-plane paper-plane',
            disabledKey: 'is_submited',
            disabledWhenBool: true,
            funcType: 'send',
            disability: 'is_admin_created',
            disability2: 'assessment_status__status_name',
            disabledDisability2: true
        }],
        modalStyle: 'icon',
        type: 'modalOpeners',
        content: '',
        linkActive: false,
        link: ''
    }],
}

export default tableColumn


// WEBPACK FOOTER //
// ./src/_pages/DashBoard/tableColumn.js